export interface InsidePage {
  src: string
  caption: string
}

export const insidePages: InsidePage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/9xCWDtFU7UCvEKjdzsGHZP/Captura-de-pantalla-2026-09-19-a-la_s_-7.02.27_p._m..png',
    caption: 'Temperature Spread & Sensor Plausibility',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/iF1JgmFZP4jxZHJNwh9nob/Captura-de-pantalla-2026-09-19-a-la_s_-7.03.23_p._m..png',
    caption: 'Regenerative Braking & Battery Acceptance',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/i65gBG2uLkUxXPMbErozJt/Captura-de-pantalla-2026-09-19-a-la_s_-7.03.40_p._m..png',
    caption: 'Case Study: Reduced Power After Fast Charging',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/nCte5t7XteuXQsvdjUyWRV/Captura-de-pantalla-2026-09-19-a-la_s_-7.03.57_p._m..png',
    caption: 'Battery Diagnostic Decision Tree',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/fJL8NwvKRufsYURhszNWWG/Captura-de-pantalla-2026-09-19-a-la_s_-7.02.52_p._m..png',
    caption: 'Battery Thermal Management Architecture',
  },
]
